import Cookies from 'js-cookie'

$(function () {
  $('.js-success-subscribe').on('click', function () {
    Cookies.set('subscribed_newsletter', 'success', { expires: 365, path: '/' })
    $(this).closest('.subscription-message').fadeOut()
  })

  $('.js-cancel-subscribe').on('click', function () {
    Cookies.set('subscribed_newsletter', 'cancel', { expires: 30, path: '/' })
    $(this).closest('.subscription-message').fadeOut()
    return false
  })
})
